/*
*@Author: dcl
*@Description: 联系我们页面
*@Date: 2022-11-14 11:30:37
*/
<template>
  <div class="ir">
    <div class="ir-txt1">通讯地址：广州市花都区风神大道11号之八二楼</div>
    <div class="ir-txt1">客服、投诉热线：020-36878670 （8:30-17:30）</div>
    <div class="ir-txt2">
      <div class="txt2-title">消费投诉处理流程：</div>
      <div class="flow">
        <div class="txt">客户投诉</div>
        <div class="pot"></div>
        <div class="txt">
          <div>询问信息</div>
          <div>受理投诉</div>
        </div>
        <div class="pot"></div>
        <div class="txt">
          <div>联系客户</div>
          <div>调查核实</div>
        </div>
        <div class="pot"></div>
        <div class="txt">
          <div>10个工作日</div>
          <div>反馈结果</div>
        </div>
        <div class="line1"></div>
        <div class="line2">
          <div class="lineTxt1">达成一致意见</div>
          <div class="lineTxt2">未达成一致意见</div>
        </div>
        <div>
          <div class="lineto">
            <div class="pot pot1"></div>
            <div class="txt">结案</div>
          </div>
          <div class="lineto">
            <div class="pot pot1"></div>
            <div class="txt">调解诉讼</div>
          </div>
        </div>
      </div>
    </div>
    <div class="ir-txt1">电子邮箱：zhangshujuan@dfl.com.cn</div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  }
};
</script>
<style scoped lang='less'>
.ir {
  .ir-txt1,
  .ir-txt2 {
    margin: 20px;
  }
  .ir-txt2 {
    .flow {
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: center;
      font-size: 12px;
      margin-left: 40px;

      .txt {
        padding: 7px;
        // height: 40px;
        // line-height: 40px;
        background-color: #ebf3ff;
        border: 1px solid #79b0ff;
        border-radius: 3px;
      }

      .pot {
        margin: 0px 10px;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 6px solid #1576ff;
      }

      .line1 {
        margin: 0px 10px;
        width: 26px;
        height: 26px;
        // background-color: #1576FF;
        border-left: 1px solid #1576ff;
        border-bottom: 1px solid #1576ff;
        transform-origin: center;
        transform: rotate(45deg);
      }

      .line2 {
        width: 100px;
        height: 37px;
        border-top: 1px solid #1576ff;
        border-bottom: 1px solid #1576ff;
        margin-left: -24px;
        position: relative;
        color: #acacac;

        .lineTxt1 {
          position: absolute;
          top: -17px;
          left: 13px;
        }

        .lineTxt2 {
          position: absolute;
          top: 35px;
          left: 7px;
        }

        // margin-top: 3px;
      }

      .lineto {
        display: flex;
        flex-direction: row;
        margin: 3px 0px;

        .pot1 {
          margin: 10px 0 0 0;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Information/relation.vue